import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { loadBreedListDemographics } from '../actions';

export const usePetBreedsDemographics = () => {
  const dispatch = useDispatch();
  const store = useSelector(({ myPets }) => ({ myPets }), shallowEqual);
  const { myPets: { breedDataDemographics } } = store;

  useEffect(() => {
    if (!breedDataDemographics.dogBreeds.length
      && !breedDataDemographics.catBreeds.length) {
      dispatch(loadBreedListDemographics());
    }
  }, [dispatch, breedDataDemographics]);

  return {
    breedDataDemographics,
  };
};
